import { CONSENT_VERSION } from '@geo-admin/shared/contract/api/signup.ts';
import { BRAND, COMPANY } from '../../lib/company.ts';
import type { LegalDoc } from '../types.ts';

export const serviceTerms: LegalDoc = {
  title: '서비스 이용약관',
  effectiveDate: CONSENT_VERSION,
  blocks: [
    {
      kind: 'p',
      text: `본 약관은 ${COMPANY.name}(이하 "회사")가 제공하는 AI 검색 노출 측정·보고 서비스 ${BRAND.name}(이하 "서비스")의 이용과 관련하여 회사와 회원 간의 권리, 의무 및 책임사항을 정함을 목적으로 합니다.`,
    },

    { kind: 'h2', text: '제1조 (정의)' },
    {
      kind: 'ol',
      items: [
        '"서비스"란 회사가 생성형 AI 검색·답변 서비스에서 회원이 지정한 검색어에 대한 답변을 반복 수집하고, 회원 브랜드의 언급·인용 여부를 집계하여 제공하는 일체의 서비스를 말합니다.',
        '"회원"이란 본 약관에 동의하고 회사의 승인을 받아 서비스 이용계약을 체결한 사업자를 말합니다.',
        '"목표 질문"이란 회원이 AI 답변에 노출되기를 원하여 회사와 협의해 등록한 질문을 말합니다.',
        '"측정치"란 회사가 일정 주기로 수집한 표본에서 산출한 언급률·인용률 및 그 부수 지표를 말합니다.',
      ],
    },

    { kind: 'h2', text: '제2조 (가입 대상과 계약의 성립)' },
    {
      kind: 'ol',
      items: [
        '서비스는 사업자만 이용할 수 있습니다. 회원은 사업자등록을 한 법인 또는 개인사업자여야 합니다.',
        '이용계약은 가입 신청만으로 성립하지 않습니다. 회사가 신청 내용을 확인하고 승인한 때에 성립합니다.',
        '회사는 신청 내용이 사실과 다르거나, 사업자가 아니거나, 서비스 제공이 기술적·정책적으로 어려운 경우 승인을 거절할 수 있습니다.',
        '회원은 가입 시 연락 가능한 휴대폰 번호를 제공하여야 하며, 회사는 해당 번호로 문자를 보내 번호가 사용 가능한지 확인합니다. 이 절차는 회원 개인의 신원을 확인하는 절차가 아닙니다.',
      ],
    },

    { kind: 'h2', text: '제3조 (서비스의 내용)' },
    {
      kind: 'ol',
      items: [
        '회사는 회원이 등록한 목표 질문을 생성형 AI 서비스에 반복해 묻고 답변을 수집하여, 브랜드 언급·인용 여부를 집계해 대시보드로 제공합니다.',
        '수집 주기·표본 수는 회사가 정하며, 서비스 화면에 표시됩니다.',
        '회사는 서비스의 품질 향상을 위해 측정 방식·지표·화면 구성을 변경할 수 있습니다.',
      ],
    },

    { kind: 'h2', text: '제4조 (측정치의 성격 — 중요)' },
    {
      kind: 'ol',
      items: [
        '생성형 AI 의 답변은 같은 질문에도 매번 달라집니다(비결정적). 따라서 측정치는 확정된 사실이 아니라 표본에서 얻은 추정치이며, 표본 수에 따른 오차를 포함합니다.',
        '회사는 측정치와 함께 표본 수를 표시합니다. 회원은 표본 수가 작은 구간의 값을 단정적인 결론으로 사용하지 않아야 합니다.',
        '회사는 특정 검색어에서의 노출·인용·순위를 보장하지 않습니다. AI 서비스 사업자의 정책·모델·색인 변경으로 측정치가 급변할 수 있으며, 이는 회사의 책임이 아닙니다.',
        '측정 대상 AI 서비스가 접근을 제한하거나 정책을 변경하여 수집이 불가능해지는 경우, 회사는 해당 항목의 제공을 중단할 수 있습니다.',
      ],
    },

    { kind: 'h2', text: '제5조 (회원의 의무)' },
    {
      kind: 'ol',
      items: [
        '회원은 가입 및 이용 과정에서 사실에 부합하는 정보를 제공해야 하며, 변경이 있으면 지체 없이 알려야 합니다.',
        '회원은 계정 정보를 타인과 공유하거나 양도할 수 없습니다. 계정 관리 소홀로 발생한 손해는 회원이 부담합니다.',
        '회원은 서비스를 통해 제공받은 자료를 회사의 사전 동의 없이 제3자에게 재판매하거나 공표할 수 없습니다.',
        '회원은 자동화된 수단으로 서비스에 과도한 부하를 주거나, 서비스의 정상적인 운영을 방해하는 행위를 해서는 안 됩니다.',
      ],
    },

    { kind: 'h2', text: '제6조 (서비스의 중단·변경)' },
    {
      kind: 'ol',
      items: [
        '회사는 설비 점검·교체, 통신 장애, 천재지변, 외부 서비스의 장애 등으로 서비스 제공을 일시 중단할 수 있습니다.',
        '회사는 운영상·기술상의 필요에 따라 서비스의 전부 또는 일부를 변경하거나 종료할 수 있으며, 종료하는 경우 서비스 화면 또는 회원이 등록한 연락처로 사전에 알립니다.',
      ],
    },

    { kind: 'h2', text: '제7조 (책임의 제한)' },
    {
      kind: 'ol',
      items: [
        '회사는 천재지변, 제3자 서비스의 장애·정책 변경 등 회사의 통제를 벗어난 사유로 발생한 손해에 대하여 책임을 지지 않습니다.',
        '회사는 회원이 측정치를 근거로 내린 의사결정의 결과에 대하여 책임을 지지 않습니다. 측정치의 성격은 제4조에 따릅니다.',
        '회사의 고의 또는 중대한 과실이 없는 한, 회사의 손해배상 책임은 회원이 해당 손해 발생 직전 3개월간 회사에 지급한 이용요금의 총액을 한도로 합니다.',
      ],
    },

    { kind: 'h2', text: '제8조 (해지와 탈퇴)' },
    {
      kind: 'ol',
      items: [
        '회원은 서비스 화면에서 언제든지 탈퇴할 수 있습니다. 탈퇴 즉시 회원의 개인정보는 개인정보처리방침에 따라 파기되고 데이터 수집이 중단됩니다.',
        '수집이 완료된 측정 기록은 특정 개인을 알아볼 수 없는 통계·지표 이력으로 보존될 수 있습니다.',
        '회사는 회원이 본 약관을 중대하게 위반한 경우 사전 통지 후 이용계약을 해지할 수 있습니다.',
      ],
    },

    { kind: 'h2', text: '제9조 (약관의 변경)' },
    {
      kind: 'ol',
      items: [
        '회사는 관련 법령을 위반하지 않는 범위에서 본 약관을 변경할 수 있습니다.',
        '변경된 약관은 시행일과 변경 사유를 명시하여 시행일 7일 전(회원에게 불리한 변경은 30일 전)부터 서비스 화면에 게시합니다.',
        '회원이 변경에 동의하지 않는 경우 탈퇴할 수 있습니다.',
      ],
    },

    { kind: 'h2', text: '제10조 (준거법과 관할)' },
    {
      kind: 'p',
      text: '본 약관은 대한민국 법령에 따라 해석되며, 서비스 이용과 관련한 분쟁은 회사의 주소지를 관할하는 법원을 제1심 관할법원으로 합니다.',
    },

    { kind: 'h2', text: '부칙' },
    { kind: 'p', text: `본 약관은 ${CONSENT_VERSION}부터 시행합니다.` },
    {
      kind: 'ul',
      items: [
        `상호 ${COMPANY.name}`,
        `대표자 ${COMPANY.ceo}`,
        `사업자등록번호 ${COMPANY.registrationNo}`,
        `통신판매업신고 ${COMPANY.mailOrderNo}`,
        `주소 ${COMPANY.address}`,
        `문의 ${COMPANY.tel} · ${COMPANY.email}`,
      ],
    },
  ],
};
